<p-panel>
    <div class="container-fluid gap-5">
        <div class="row">
            <div class="col">
                @if (formReady) {
                    <app-reactive-form-builder
                        #builderRef
                        (formChanges)="reactiveFormChanges($event[0], $event[1])"
                        (goBack)="goBack()"
                        [form]="form.formFields"
                        [dropdownLoadTrigger]="dropdownLoadTrigger"
                        [id]="getRegisterId()"
                        [request]="request"
                        [getRequest]="visitasApi.visitasTrasiego.GET">
                    </app-reactive-form-builder>
                }
            </div>
        </div>
    </div>
</p-panel>
